(function () {
  // =========================
  // HERO SLIDESHOW (rechts rotierend)
  // =========================
  function initHeroSliders() {
    document.querySelectorAll("[data-ag-hero]").forEach((root) => {
      if (root.dataset.agHeroReady === "true") return;
      root.dataset.agHeroReady = "true";

      const slides = Array.from(root.querySelectorAll(".ag-hero__slide"));
      const dots = Array.from(root.querySelectorAll(".ag-hero__dot"));

      if (!slides.length) return;

      let index = 0;
      const intervalMs = parseInt(root.getAttribute("data-interval"), 10) || 4500;
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      let timer;

      function setActive(i) {
        slides.forEach((slide, idx) => {
          const active = idx === i;
          slide.classList.toggle("is-active", active);
          slide.setAttribute("aria-hidden", active ? "false" : "true");
        });
        dots.forEach((dot, idx) => {
          const active = idx === i;
          dot.classList.toggle("is-active", active);
          dot.setAttribute("aria-pressed", active ? "true" : "false");
        });
        index = i;
      }

      function stop() {
        window.clearInterval(timer);
        root.classList.add("is-paused");
      }

      function start() {
        window.clearInterval(timer);
        root.classList.remove("is-paused");
        if (slides.length <= 1 || reduceMotion || document.hidden) return;
        timer = window.setInterval(() => setActive((index + 1) % slides.length), intervalMs);
      }

      dots.forEach((dot, i) => {
        dot.addEventListener("click", () => {
          setActive(i);
          start();
        });
      });

      setActive(0);
      start();

      document.addEventListener("visibilitychange", () => document.hidden ? stop() : start());
    });
  }

  // =========================
  // HEADER BAR STICKY
  // =========================
  function initHeaderBarSticky() {
    const hdr = document.querySelector("[data-ag-header-bar]");
    if (!hdr) return;

    const topbar = document.querySelector(".ag-topbar");
    let spacer = document.querySelector("[data-ag-hdr-spacer]");

    if (!spacer) {
      spacer = document.createElement("div");
      spacer.setAttribute("data-ag-hdr-spacer", "");
      hdr.insertAdjacentElement("afterend", spacer);
    }

    function topbarHeight() {
      return topbar ? topbar.offsetHeight : 0;
    }

    function setFixed(on) {
      if (on) {
        const h = hdr.offsetHeight;
        hdr.classList.add("is-fixed");
        spacer.style.height = `${h}px`;
      } else {
        hdr.classList.remove("is-fixed");
        spacer.style.height = "0px";
      }
    }

    function onScroll() {
      const shouldFix = window.scrollY > topbarHeight();
      const isFixed = hdr.classList.contains("is-fixed");

      if (shouldFix !== isFixed) setFixed(shouldFix);
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", () => {
      if (hdr.classList.contains("is-fixed")) {
        spacer.style.height = `${hdr.offsetHeight}px`;
      }
    });

    onScroll();
  }

  // =========================
  // WISHLIST (LocalStorage)
  // =========================
  const WKEY = "ag_wishlist_handles";

  function getWish() {
    try {
      return JSON.parse(localStorage.getItem(WKEY) || "[]");
    } catch {
      return [];
    }
  }

  function setWish(list) {
    localStorage.setItem(WKEY, JSON.stringify(list));
  }

  function refreshWishUI() {
    const list = getWish();

    document.querySelectorAll("[data-ag-wish]").forEach((btn) => {
      const handle = btn.getAttribute("data-handle");
      const active = list.includes(handle);

      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });

    document.querySelectorAll("[data-ag-wish-count]").forEach((el) => {
      if (list.length > 0) {
        el.textContent = String(list.length);
        el.style.display = "flex";
      } else {
        el.textContent = "";
        el.style.display = "none";
      }
    });
  }

  function initWishlist() {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-ag-wish]");
      if (!btn) return;

      e.preventDefault();

      const handle = btn.getAttribute("data-handle");
      const list = getWish();
      const next = list.includes(handle)
        ? list.filter((h) => h !== handle)
        : [...list, handle];

      setWish(next);
      refreshWishUI();

      if (document.querySelector("[data-ag-wishlist-page]")) {
        renderWishlistPage();
      }
    });

    refreshWishUI();
  }

  // =========================
  // WISHLIST PAGE RENDER
  // =========================
  function renderWishlistPage() {
    const root = document.querySelector("[data-ag-wishlist-page]");
    if (!root) return;

    const empty = root.querySelector("[data-ag-wishlist-empty]");
    const items = Array.from(root.querySelectorAll("[data-ag-wish-item]"));
    const handles = getWish();

    if (!handles.length) {
      items.forEach((it) => (it.style.display = "none"));
      if (empty) empty.style.display = "block";
      return;
    }

    let shown = 0;

    items.forEach((it) => {
      const h = it.getAttribute("data-handle");
      const on = handles.includes(h);

      it.style.display = on ? "" : "none";
      if (on) shown++;
    });

    if (empty) empty.style.display = shown ? "none" : "block";

    refreshWishUI();
  }

  // =========================
  // CART COUNT
  // =========================
  async function updateCartCount() {
    try {
      const res = await fetch("/cart.js", {
        headers: { Accept: "application/json" },
      });

      if (!res.ok) return;

      const cart = await res.json();
      const unique = Array.isArray(cart.items) ? cart.items.length : 0;

      document.querySelectorAll("[data-ag-cart-count]").forEach((el) => {
        if (unique > 0) {
          el.textContent = String(unique);
          el.style.display = "flex";
        } else {
          el.textContent = "";
          el.style.display = "none";
        }
      });
    } catch (e) {
      console.error("updateCartCount failed", e);
    }
  }
  // =========================
  // QTY STEPPER + AJAX ATC
  // =========================
  function initQtyAndATC() {
    document.addEventListener("click", (e) => {
      const minus = e.target.closest("[data-ag-qty-minus]");
      const plus = e.target.closest("[data-ag-qty-plus]");

      if (!minus && !plus) return;

      const wrap = e.target.closest("[data-ag-qtywrap]");
      if (!wrap) return;

      const input = wrap.querySelector("input[data-ag-qty]");
      if (!input) return;

      const current = parseInt(input.value || "1", 10) || 1;
      const min = parseInt(input.getAttribute("min") || "1", 10) || 1;
      const max = parseInt(input.getAttribute("max") || "9999", 10) || 9999;

      let next = current;

      if (minus) next = Math.max(min, current - 1);
      if (plus) next = Math.min(max, current + 1);

      input.value = String(next);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    async function addToCart(btn) {
      if (
        btn.disabled ||
        btn.getAttribute("aria-disabled") === "true" ||
        btn.dataset.agSoldOut === "true" ||
        btn.dataset.agAdding === "true"
      ) {
        return;
      }

      const variantId = btn.getAttribute("data-variant");
      if (!variantId) return;

      const container =
        btn.closest("[data-ag-product]") || btn.closest("[data-ag-pdp]");
      const qtyInput = container
        ? container.querySelector("input[data-ag-qty]")
        : null;
      const quantity = qtyInput ? parseInt(qtyInput.value || "1", 10) || 1 : 1;

      btn.disabled = true;
      btn.dataset.agAdding = "true";
      btn.classList.add("is-loading");

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: variantId,
            quantity,
          }),
        });

        if (!res.ok) throw new Error("ATC failed");

        await updateCartCount();

        btn.classList.add("is-added");
        setTimeout(() => btn.classList.remove("is-added"), 900);
      } catch (err) {
        console.error(err);
        alert("Konnte nicht in den Warenkorb legen. Bitte erneut versuchen.");
      } finally {
        if (btn.dataset.agSoldOut !== "true") {
          btn.disabled = false;
        }
        delete btn.dataset.agAdding;
        btn.classList.remove("is-loading");
      }
    }

    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-ag-atc]");
      if (!btn) return;

      e.preventDefault();
      addToCart(btn);
    });

    document.addEventListener("submit", (e) => {
      const form = e.target.closest(".ag-sami-product-form");
      if (!form) return;

      e.preventDefault();
      const btn = form.querySelector("[data-ag-atc]");
      if (btn) addToCart(btn);
    });
  }

  // =========================
  // COLLECTION SEARCH
  // =========================
  function initClientSearch() {
    document.querySelectorAll("[data-ag-search]").forEach((wrap) => {
      if (wrap.dataset.agSearchReady === "1") return;
      wrap.dataset.agSearchReady = "1";

      const input = wrap.querySelector("input");
      const clearButton = wrap.querySelector("[data-ag-search-clear]");
      const gridSel = wrap.getAttribute("data-target") || "[data-ag-grid]";
      const grid = document.querySelector(gridSel);
      const section = wrap.closest(".ag-collection");
      const status = section?.querySelector("[data-ag-search-status]");
      const pagination = section?.querySelector("[data-ag-search-pagination]");

      if (!input || !grid) return;

      const originalCards = Array.from(grid.children);
      let debounceTimer;
      let activeRequest;

      const normalize = (value) =>
        value
          .toLocaleLowerCase("de")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "");

      function setStatus(message = "") {
        if (!status) return;
        status.textContent = message;
        status.hidden = !message;
      }

      function restoreProducts() {
        activeRequest?.abort();
        wrap.classList.remove("is-loading");
        originalCards.forEach((card) => (card.hidden = false));
        grid.replaceChildren(...originalCards);
        if (pagination) pagination.hidden = false;
        setStatus();
        refreshWishUI();
        document.dispatchEvent(new CustomEvent("collectionUpdate"));
      }

      function showLocalFallback(query) {
        const normalizedQuery = normalize(query);
        let matches = 0;

        grid.replaceChildren(...originalCards);
        originalCards.forEach((card) => {
          const haystack = normalize(card.getAttribute("data-search") || card.getAttribute("data-title") || "");
          card.hidden = !haystack.includes(normalizedQuery);
          if (!card.hidden) matches += 1;
        });

        setStatus(matches === 1 ? "1 Produkt gefunden" : `${matches} Produkte gefunden`);
      }

      async function searchProducts(query) {
        activeRequest?.abort();
        const request = new AbortController();
        activeRequest = request;
        wrap.classList.add("is-loading");
        setStatus("Produkte werden gesucht …");

        const url = new URL(Theme.routes.search_url, window.location.origin);
        url.searchParams.set("q", query);
        url.searchParams.set("type", "product");
        url.searchParams.set("options[prefix]", "last");
        url.searchParams.set("section_id", "ag-live-search-results");

        try {
          const response = await fetch(url, {
            signal: request.signal,
            headers: { "X-Requested-With": "XMLHttpRequest" },
          });
          if (!response.ok) throw new Error(`Live search failed: ${response.status}`);

          const markup = await response.text();
          const documentFragment = new DOMParser().parseFromString(markup, "text/html");
          const results = documentFragment.querySelector("[data-ag-live-results]");
          if (!results) throw new Error("Live search returned no result container");

          const resultCount = Number(results.dataset.resultCount || results.children.length);
          grid.replaceChildren(...Array.from(results.children));
          setStatus(
            resultCount === 0
              ? wrap.dataset.emptyMessage || "Keine passenden Produkte gefunden."
              : resultCount === 1
                ? "1 Produkt gefunden"
                : `${resultCount} Produkte gefunden`
          );
          refreshWishUI();
          document.dispatchEvent(new CustomEvent("collectionUpdate"));
        } catch (error) {
          if (error.name !== "AbortError") {
            console.error(error);
            showLocalFallback(query);
          }
        } finally {
          if (activeRequest === request) wrap.classList.remove("is-loading");
        }
      }

      function handleSearch() {
        const query = (input.value || "").trim();
        clearButton?.toggleAttribute("hidden", !query);
        if (pagination) pagination.hidden = Boolean(query);

        window.clearTimeout(debounceTimer);
        if (!query) {
          restoreProducts();
          return;
        }

        debounceTimer = window.setTimeout(() => searchProducts(query), 250);
      }

      input.addEventListener("input", handleSearch);
      input.addEventListener("search", handleSearch);
      input.addEventListener("keydown", (event) => {
        if (event.key === "Enter") event.preventDefault();
      });

      clearButton?.addEventListener("click", () => {
        input.value = "";
        clearButton.hidden = true;
        restoreProducts();
        input.focus();
      });
    });
  }

  // =========================
  // HOME PRODUCT TABS + CAROUSEL
  // =========================
  function initProductShowcases() {
    document.querySelectorAll("[data-ag-product-showcase]").forEach((root) => {
      if (root.dataset.agShowcaseReady === "1") return;
      root.dataset.agShowcaseReady = "1";

      const tabs = Array.from(root.querySelectorAll("[data-ag-products-tab]"));
      const panels = Array.from(root.querySelectorAll("[data-ag-products-panel]"));
      const prev = root.querySelector("[data-ag-products-prev]");
      const next = root.querySelector("[data-ag-products-next]");
      const link = root.querySelector("[data-ag-products-link]");

      const activePanel = () => panels.find((panel) => !panel.hidden);
      const activeTrack = () => activePanel()?.querySelector("[data-ag-products-track]");

      function updateControls() {
        const track = activeTrack();
        if (!track) return;

        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= maxScroll - 4 || maxScroll === 0;

        if (link) {
          const url = activePanel()?.getAttribute("data-collection-url");
          if (url) link.href = url;
        }
      }

      tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          const id = tab.getAttribute("data-ag-products-tab");

          tabs.forEach((item) => {
            const isActive = item === tab;
            item.classList.toggle("is-active", isActive);
            item.setAttribute("aria-selected", isActive ? "true" : "false");
          });

          panels.forEach((panel) => {
            const isActive = panel.getAttribute("data-ag-products-panel") === id;
            panel.hidden = !isActive;
            panel.classList.toggle("is-active", isActive);
          });

          activeTrack()?.scrollTo({ left: 0, behavior: "auto" });
          updateControls();
        });
      });

      function scrollProducts(direction) {
        const track = activeTrack();
        if (!track) return;
        track.scrollBy({ left: direction * track.clientWidth * 0.82, behavior: "smooth" });
      }

      prev?.addEventListener("click", () => scrollProducts(-1));
      next?.addEventListener("click", () => scrollProducts(1));
      panels.forEach((panel) => {
        panel.querySelector("[data-ag-products-track]")?.addEventListener("scroll", updateControls, { passive: true });
      });
      window.addEventListener("resize", updateControls);
      updateControls();
    });
  }

  // =========================
  // BOOT
  // =========================
  function bootAG() {
    initHeroSliders();
    initWishlist();
    initQtyAndATC();
    initClientSearch();
    initProductShowcases();
    updateCartCount();
    initHeaderBarSticky();

    if (document.querySelector("[data-ag-wishlist-page]")) {
      renderWishlistPage();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootAG);
  } else {
    bootAG();
  }

  document.addEventListener("shopify:section:load", initProductShowcases);
  document.addEventListener("shopify:section:load", initClientSearch);
  document.addEventListener("shopify:section:load", initHeroSliders);
})();
